import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Icons,
} from '@commenda/kakashi';

import { useRouter } from 'next/router';
import { useState } from 'react';

import { deleteSalesTaxProduct } from '@commenda/api';
import SalesTaxProductConfirmationModal from './product-action-confirmation-modal';

interface SalesTaxProductDeleteModalProps {
  isDeleteModalOpen: boolean;
  setIsDeleteModal: (isTwoFactorModalOpen: boolean) => void;
  name: string;
  id: string;
  corporationId: number;
  mutate: () => void;
  setNotification: (TNotification) => void;
}

const SalesTaxProductDeleteModal = ({
  isDeleteModalOpen,
  setIsDeleteModal,
  name,
  id,
  corporationId,
  mutate,
  setNotification,
}: SalesTaxProductDeleteModalProps) => {
  const router = useRouter();

  const [isConfirmationModalOpen, setIsConfirmationModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleDelete = async () => {
    const res = await deleteSalesTaxProduct(undefined, id, corporationId);

    if (!res.success) {
      setNotification({
        show: true,
        valid: false,
        title: 'Error',
        message: res.error,
      });
      setIsSubmitting(false);
      return;
    }
    await mutate();
    setIsConfirmationModal(true);
    setIsDeleteModal(false);
    setIsConfirmationModal(true);
    router.push(`/sales-tax/${corporationId}/products`);
  };

  return (
    <>
      <SalesTaxProductConfirmationModal
        title="Product deleted successfully!"
        message={`${name} was permanently deleted.`}
        isConfirmationModalOpen={isConfirmationModalOpen}
        setIsConfirmationModal={setIsConfirmationModal}
        handleConfirmation={() => {
          setIsConfirmationModal(false);
          router.push('/sales-tax/1');
        }}
      />
      <Dialog open={isDeleteModalOpen} onOpenChange={setIsDeleteModal}>
        <DialogContent
          className="min-w-[600px] p-0"
          hideCloseIcon
          preventCloseOnOutsideClick
        >
          <DialogHeader className="border-b-0 pb-1">
            <div className="flex flex-col gap-4">
              <div className="flex items-center justify-center size-12 bg-bg-error rounded-lg">
                <Icons.Trash01 className="size-5 text-text-error" />
              </div>
              <DialogTitle>Delete product?</DialogTitle>
            </div>
          </DialogHeader>

          <div className="px-6 txt-small-regular text-text-tertiary">
            <span className="font-bold">{name}</span> will be deleted
            permanently from your records. Your existing transactions will not
            be affected.
          </div>

          <DialogFooter className="border-t-0">
            <Button
              variant="secondary"
              size="sm"
              onClick={() => setIsDeleteModal(false)}
            >
              Cancel
            </Button>
            <Button
              disabled={isSubmitting}
              variant="destructive-primary"
              onClick={handleDelete}
              size="sm"
            >
              Delete product
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SalesTaxProductDeleteModal;
